import React, { useEffect, useRef, useState } from "react";
import StyledText from "../../../components/StyledComponents/StyledText";
import DnDIcon from "../../../assets/icons/DnDIcon";
import { StyledBox, StyledHr, Tag } from "./ContactOverview";
import { CorporateTheme } from "../../../utils/themes";
import styled from "styled-components";
import { useTheme } from "../../../middleware/ThemeContext";
import SearchBar from "../../../components/searchBar/SearchBar";
import FieldsGroupAccordion from "./fieldsGroupAccordion";
import DuplicateIcon from "../../../assets/icons/DuplicateIcon";
import MenuIcon from "../../../assets/icons/MenuIcon";
import FileUpload from "../../../components/StyledComponents/StyledFileUpload";
import CustomFieldsIcon from "../../../assets/icons/CustomFieldsIcon";
import NoData from "../../../components/listing/NoData";
import NoFieldsStateIcon from "../../../assets/icons/NoFieldsStateIcon";
import SyncIcon from "../../../assets/icons/SyncIcon";
import { Button } from "../../../components/form/Button";
import BulkUpdateModal from "../../searchQuery/BulkUpdateModal";
import AddIcon from "../../../assets/icons/AddIcon";
import PlusIcon from "../../../assets/icons/PlusIcon";
import { getIconForDataType } from "../../../components/FormBuilder/FieldSettings/fieldSettingsHelper";

interface ContactCustomFieldsProps {
  data: any;
  refetch?: () => void;
  isLoading?: boolean;
  isStandard?: boolean;
}

const ContactCustomFields: React.FC<ContactCustomFieldsProps> = ({ data, refetch, isLoading, isStandard }) => {
  const { theme } = useTheme();
  const [search, setSearch] = useState('');
  const [resultSelectedIds, setResultSelectedIds] = useState<number[]>([]);
  const [showBulkUpdateModal, setShowBulkUpdateModal] = useState(false);

  const uniqueDataTypes = Array.from(
    new Set([
      ...(data?.cfr?.formSubmissions?.submissionValues ?? []),
      ...(data?.cfr?.crmFieldValues ?? [])
    ].map(item => item.field.dataType))
  );

  const allItems = [
    ...(data?.cfr?.crmFieldValues ?? []),
    ...(data?.cfr?.formSubmissions?.submissionValues ?? [])
  ];

  const filteredItems = allItems.filter(item => {
    if (isStandard === true) return item.field.isStandard === true;
    if (isStandard === false) return item.field.isStandard === false;
    return true; // default - if prop not passed
  });

  const filterData = filteredItems.filter(item =>
    item?.field?.name?.toLowerCase().includes(search.toLowerCase()) ||
    item?.field?.dataType?.toLowerCase().includes(search.toLowerCase()) ||
    item?.value?.toLowerCase().includes(search.toLowerCase())
  )
    .sort((a, b) => {
      const nameA = a?.field?.name?.toLowerCase() ?? "";
      const nameB = b?.field?.name?.toLowerCase() ?? "";
      return nameA.localeCompare(nameB); // ✅ sorts alphabetically A → Z
    });
  // .sort((a, b) => (b?.field?.id ?? 0) - (a?.field?.id ?? 0));

  const prevShowBulkUpdateModal = useRef(showBulkUpdateModal);

  useEffect(() => {
    if (prevShowBulkUpdateModal.current === true && showBulkUpdateModal === false) {
      refetch?.();
    }
    prevShowBulkUpdateModal.current = showBulkUpdateModal;
  }, [showBulkUpdateModal, refetch]);
  return (
    <>
      {/* <StyledBox theme={theme} className=""> */}
      {/* <div className="d-flex align-items-center justify-content-between">
          <StyledText
            fontSize="16px"
            fontWeight={700}
            textColor={theme.CorporateTheme.colors.headerColor}
            className="mb-0 ps-3 py-3"
          >
            All fields used by this user
          </StyledText>
          <Button
            theme={theme}
            type="button"
            $variant="add"
            className="me-3"
            onClick={() => {setShowBulkUpdateModal(true); setResultSelectedIds([data.id]);}}
            // disabled={isSubmitting || !isFormValid()}
          >
            <AddIcon color={theme.CorporateTheme.colors.background} />
            Add Fields
          </Button>
        </div> */}
      <div className="d-flex align-items-center justify-content-between gap-2">
        <SearchBar
          placeholder={isStandard ? "Search standard fields here" : "Search custom fields here"}
          style={{ width: '100%', height: '40px' }}
          onSearchChange={value => setSearch(value)}
          searchTerm={search}

        />
        <Button
          theme={theme}
          type="button"
          $variant="customButton"
          radius='5px'
          width='40px'
          height='40px'
          btnPadding='0px'
          btnBg={theme.CorporateTheme.colors.primary}
          onClick={() => { setShowBulkUpdateModal(true); setResultSelectedIds([data.id]); }}
        // disabled={isSubmitting || !isFormValid()}
        >
          <PlusIcon color={theme.CorporateTheme.colors.background} size={14} />
        </Button>
      </div>

      {/* <StyledHr theme={theme} className="me-4" />
        <div className="d-flex flex-column align-items-center justify-content-center my-4">
          <StyledText
            fontSize="59px"
            fontWeight={700}
            textColor={theme.CorporateTheme.colors.count}
            style={{fontFamily:'Lato'}}
          >
            {
              (data?.cfr?.formSubmissions?.submissionValues?.length ?? 0) + 
              (data?.cfr?.crmFieldValues?.length ?? 0)
            }
          </StyledText>
          <StyledText
            fontSize="14px"
            fontWeight={600}
            textColor={theme.CorporateTheme.colors.primary}
            className="mt-2"
          >
            Total custom fields used
          </StyledText>
        </div> */}
      {/* <div className="mx-3 position-relative">
          <SearchBar 
            placeholder="Search custom fields here"
            style={{ width: '100%' }}
            onSearchChange={value => setSearch(value)}
            searchTerm={search}
          />
          
        </div> */}
      {filterData.length > 0 ?
        <>
          <div className="d-flex flex-column mt-3">

            {uniqueDataTypes.map((type, index) => (
              <FieldsGroupAccordion
                key={index}
                ID={data.id}
                Email={data.email}
                data={filterData}
                type={type}
                isOpen={index === 0}
                // getFile={(key: string) => getFile(key)}
                icon={getIconForDataType(
                  type,
                  { size: 16, color: theme.CorporateTheme.colors.headerColor, className: 'me-2' }
                )}
                searchTerm={search}
                refetch={refetch}
                scope='CONTACT'
              />
            ))}

          </div>
        </>
        :
        <NoData
          title="No Field Found"
          isField={true}
        />
        // <NoFieldsStateIcon />
      }
      {/* </StyledBox> */}
      <BulkUpdateModal
        recordIds={resultSelectedIds}
        show={showBulkUpdateModal}
        onClose={() => { setShowBulkUpdateModal(false); setResultSelectedIds([]) }}
        scope={"contact"} // Pass your columns data here
      />
    </>
  );
};

export default ContactCustomFields;

export const StyledCustomFieldBar = styled.div`
  background: ${({ theme }) => theme.CorporateTheme.colors?.filterBG};
  border-radius: 4px;
  border: 0.5px solid ${({ theme }) => theme.CorporateTheme.colors.border};
  padding: 10px;
  display: flex;
  margin: 4px 10px;
  gap: 20px;
  align-items: center;
  height: 35px;
`;

